import { defineMessages } from 'react-intl';

export const searchInputMessages = defineMessages({
  clearSearch: {
    defaultMessage: 'Clear search',
    id: '4YJHutR26p',
  },
});
